import { render } from "./OrderViewKiosk.vue?vue&type=template&id=1038c6aa&scoped=true"
import script from "./OrderViewKiosk.vue?vue&type=script&lang=js"
export * from "./OrderViewKiosk.vue?vue&type=script&lang=js"

import "./OrderViewKiosk.vue?vue&type=style&index=0&id=1038c6aa&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Sebastian\\Desktop\\-taptasty-order\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1038c6aa"]])

export default __exports__